import React from 'react';
import { PurchaseSummary } from '../../../types/purchases/BasePurchase';
import { formatCurrency } from '../../../utils/formatCurrency';
import SvgIcon from '../../SvgIcon/SvgIcon';

interface PurchaseSummaryCardProps {
  purchase: PurchaseSummary;
  /** Botones de acción (Continuar/Cancelar, Asentar, etc.) renderizados a la derecha. */
  actions: React.ReactNode;
}

/**
 * 🧾 Tarjeta reutilizable para listar una compra en los modales de
 * "Compras Pendientes" y "Compras por Asentar". Reemplaza la tabla plana
 * anterior por un diseño responsive (igual en móvil y escritorio) con
 * mejor jerarquía visual.
 */
const PurchaseSummaryCard: React.FC<PurchaseSummaryCardProps> = ({
  purchase,
  actions,
}) => {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-stroke p-4 transition hover:border-primary/40 hover:shadow-sm dark:border-strokedark sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-1 flex-col gap-2">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-gray-900 text-sm font-semibold dark:text-white">
            {purchase.documentNumber || '—'}
          </span>
          <span className="rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary">
            {purchase.documentType?.name || '—'}
          </span>
        </div>

        <div className="text-gray-600 dark:text-gray-300 flex flex-wrap items-center gap-x-5 gap-y-1 text-sm">
          <span className="flex items-center gap-1.5">
            <SvgIcon name="store" width={14} height={14} />
            {purchase.supplier?.name || '—'}
          </span>
          <span className="flex items-center gap-1.5">
            <SvgIcon name="calendar" width={14} height={14} />
            {purchase.purchaseDate || '—'}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between gap-4 sm:flex-col sm:items-end sm:justify-center sm:gap-2">
        <span className="flex items-center gap-1.5 text-base font-semibold text-gray-900 dark:text-white">
          <SvgIcon name="dollar" width={16} height={16} className="text-primary" />
          ${formatCurrency(purchase.total)}
        </span>
        <div className="flex items-center gap-2">{actions}</div>
      </div>
    </div>
  );
};

export default PurchaseSummaryCard;
